<template lang="pug">
  v-flex(xs6 sm5 md4)
    v-card(height="100%")
      v-card-title.conversations Conversations

      v-divider

      v-list.contact-list.pb-0(two-line)
        template(v-for="(conversation, index) in conversations")
          v-list-tile(
            data-cy="contact-conversation"
            :key="conversation.id"
            @click="desiredConversation = conversation"
            :class="{ 'blue lighten-5': desiredConversation.id === conversation.id }"
            avatar
          )
            a(
              v-bind:href="'/contacts/' + conversation.contact.id"
              target="_blank"
              v-if="desiredConversation.id === conversation.id"
            )
              liondesk-avatar(
                :color="conversation.contact | getFullName | getInitials | generateRandomColor('dark')"
                :text="conversation.contact | getFullName | getInitials | replaceBlankName"
                text-classes="white--text title"
                size="42px"
              )
            liondesk-avatar(
              v-else
              :color="conversation.contact | getFullName | getInitials | generateRandomColor('dark')"
              :text="conversation.contact | getFullName | getInitials | replaceBlankName"
              text-classes="white--text title"
              size="42px"
            )
            v-list-tile-content.ml-3
              a(
                v-bind:href="'/contacts/' + conversation.contact.id"
                target="_blank"
                v-if="desiredConversation.id === conversation.id"
              )
                v-list-tile-title {{ conversation.contact | getFullName | replaceBlankName }}
              v-list-tile-title(v-else) {{ conversation.contact | getFullName | replaceBlankName }}
              v-list-tile-sub-title(v-if="!conversation.last_text.error")
                span {{ conversationLastSender(conversation) }}: {{ conversation.last_text.body | safePlainText }}
              v-list-tile-sub-title.message__error(v-if="conversation.last_text.error")
                v-icon.message__error__title warning
                span.message__error__title {{ errorTitle(conversation.last_text) }}
            v-list-tile-action
              v-list-tile-action-text {{ conversation.last_text.created_at | distanceInWordsToNow }} ago
          v-divider
        v-list-tile(v-if="hasMoreConversationsToLoad" @click="$emit('load-more-callback')") Load More
</template>

<script>
import { distanceInWordsToNow } from 'date-fns';
import { createNamespacedHelpers } from 'vuex';
import { safePlainText } from '@/Core/filters/safeContent';
import TitleBar from '@/Core/components/TitleBar';
import LiondeskAvatar from '@/Core/components/LiondeskAvatar';
import getInitials from '@/Core/filters/getInitials';
import getFullName from '@/Core/filters/getFullName';
import replaceBlankName from '@/Core/filters/replaceBlankName';
import generateRandomColor from '@/Core/utilities/randomColorGenerator';
import { DIRECTIONS, TEXT_ERROR_TYPES, TEXT_CUSTOM_ERROR_TITLE } from '../config';

const { mapState: mapConversationsState, mapActions: mapConversationsActions } =
  createNamespacedHelpers('conversations');

export default {
  components: {
    TitleBar,
    LiondeskAvatar,
  },

  data() {
    return {
      desiredConversation: {},
    };
  },

  computed: {
    ...mapConversationsState(['hasMoreConversationsToLoad']),
  },

  props: {
    // The desired conversations for the users
    conversations: Array,
    // The current selected conversation
    value: Object,
  },

  filters: {
    getInitials,
    generateRandomColor,
    distanceInWordsToNow,
    replaceBlankName,
    safePlainText,
    // Filter to output the fullname, given a conversation with `first_name` and `last_name` fields.
    getFullName,
  },

  mounted() {
    this.desiredConversation = this.value;
  },

  watch: {
    value: {
      handler(value) {
        this.desiredConversation = value;
      },
      deep: true,
    },
    desiredConversation: {
      async handler(value) {
        if (value.contact) {
          await this.checkContactsOptInStatuses([this.desiredConversation.contact.id]);
        }
        this.$emit('input', value);
      },
      deep: true,
    },
  },

  methods: {
    ...mapConversationsActions(['checkContactsOptInStatuses']),
    /**
     * Returns whoever sends the last text in this conversation
     *
     * @param {Object} The conversation object
     * @returns {String} The text stating who sends the last text on this particular conversation
     */
    conversationLastSender({ contact: { first_name: firstName }, last_text: { direction } }) {
      return (
        {
          [DIRECTIONS.Outgoing]: 'Me',
          [DIRECTIONS.Incoming]: firstName,
        }[direction] || ''
      );
    },
    errorTitle(conversation) {
      if (TEXT_ERROR_TYPES[conversation.direction]) return TEXT_ERROR_TYPES[conversation.direction];
      return TEXT_CUSTOM_ERROR_TITLE;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-list.contact-list {
  padding: 0px;
  height: calc(100vh - 170px);
}

.v-card__title.conversations {
  padding-top: 21px;
  padding-bottom: 20px;
}

.v-list__tile__action {
  min-width: 120px;
}

.message__error {
  .message__error__title {
    color: var(--v-error-darken1);
  }
}
</style>
